module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-preview",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "min-height": "300px",
      "min-width": "300px"
    },
    attrs: {
      "id": ("map-preview-" + _vm.id)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-112aa1de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markerEdit/MapPreview.vue
// module id = 1020
// module chunks = 1